module.exports = __webpack_public_path__ + "media/control_acceso/bolardos_labeled-7ae4836f.png";